<template>
  <ts-card>
    <div
      class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
    >
      <h4 class="ts-text-sm">
        {{
          $t(
            'school.academic.setup.program.subject.activity_subjects.new_activity_subject'
          )
        }}
      </h4>
      <ts-modal-close-button />
    </div>
    <ts-card-wrapper>
      <form>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group m-b-5">
              <label class="col-form-label control-label required">
                {{
                  $t(
                    'school.academic.setup.program.subject.activity_subjects.subject_(en)'
                  )
                }}
              </label>
              <div>
                <input
                  class="form-control"
                  v-model="model.subject_name_foreign"
                  :class="{
                    'is-invalid': errors.has('subject_name_foreign')
                  }"
                />
                <div
                  class="invalid-feedback"
                  v-if="errors.has('subject_name_foreign')"
                >
                  {{ errors.first('subject_name_foreign') }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group m-b-5">
              <label class="col-form-label control-label">
                {{
                  $t(
                    'school.academic.setup.program.subject.activity_subjects.subject_(kh)'
                  )
                }}
              </label>
              <div>
                <input
                  class="form-control"
                  v-model="model.subject_name_native"
                  :class="{
                    'is-invalid': errors.has('subject_name_native')
                  }"
                />
                <div
                  class="invalid-feedback"
                  v-if="errors.has('subject_name_native')"
                >
                  {{ errors.first('subject_name_native') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group m-b-5">
              <label class="col-form-label control-label required">
                {{
                  $t(
                    'school.academic.setup.program.subject.activity_subjects.ministrySubject_(en)'
                  )
                }}
              </label>
              <div>
                <input
                  class="form-control"
                  v-model="model.ministry_name_foreign"
                  :class="{
                    'is-invalid': errors.has('ministry_name_foreign')
                  }"
                />
                <div
                  class="invalid-feedback"
                  v-if="errors.has('ministry_name_foreign')"
                >
                  {{ errors.first('ministry_name_foreign') }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group m-b-5">
              <label class="col-form-label control-label">
                {{
                  $t(
                    'school.academic.setup.program.subject.activity_subjects.ministrySubject_(kh)'
                  )
                }}
              </label>
              <div>
                <input
                  class="form-control"
                  v-model="model.ministry_name_native"
                  :class="{
                    'is-invalid': errors.has('ministry_name_native')
                  }"
                />
                <div
                  class="invalid-feedback"
                  v-if="errors.has('ministry_name_native')"
                >
                  {{ errors.first('ministry_name_native') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group m-b-5">
              <label class="col-form-label control-label">
                {{
                  $t(
                    'school.academic.setup.program.subject.activity_subjects.order'
                  )
                }}
              </label>
              <div>
                <ts-input
                  type="number"
                  class="form-control"
                  v-model.number="model.subject_order"
                />
                <small
                  class="f-s-12 text-grey-darker"
                  style="font-size: 10px !important;"
                >
                  {{
                    $t(
                      'school.academic.setup.program.subject.activity_subjects.khmer_secondary_progam_only'
                    )
                  }}
                </small>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group m-b-5">
              <label class="col-form-label control-label">
                {{
                  $t(
                    'school.academic.setup.program.subject.activity_subjects.total_hour'
                  )
                }}
              </label>
              <div>
                <ts-input
                  type="number"
                  class="form-control"
                  v-model.number="model.total_hour"
                />
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group m-b-5">
              <label class="col-form-label control-label">
                {{
                  $t(
                    'school.academic.setup.program.subject.activity_subjects.credit_theory'
                  )
                }}
              </label>
              <div>
                <ts-input
                  type="number"
                  class="form-control"
                  v-model.number="model.credit_theory"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group m-b-5">
              <label class="col-form-label control-label">
                {{
                  $t(
                    'school.academic.setup.program.subject.activity_subjects.credit_practice'
                  )
                }}
              </label>
              <div>
                <ts-input
                  class="form-control"
                  v-model.number="model.credit_practice"
                />
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group m-b-5">
              <label class="col-form-label control-label">
                {{
                  $t(
                    'school.academic.setup.program.subject.activity_subjects.credit_intern'
                  )
                }}
              </label>
              <div>
                <ts-input
                  type="number"
                  class="form-control"
                  v-model.number="model.credit_intern"
                />
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group m-b-5">
              <label class="col-form-label control-label required">
                {{
                  $t(
                    'school.academic.setup.program.subject.activity_subjects.display'
                  )
                }}
              </label>
              <div>
                <ts-select
                  class="form-control"
                  v-model="model.display_column"
                  :class="{ 'is-invalid': errors.has('display_column') }"
                  :options="[
                    { text: 'ខ្មែរ', value: 1 },
                    { text: 'English', value: 2 }
                  ]"
                />
                <div
                  class="invalid-feedback"
                  v-if="errors.has('display_column')"
                >
                  {{ errors.first('display_column') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-12">
            <div class="ts-bg-gray-200 ts-p-2 ts-rounded">
              <div class="d-flex justify-content-between">
                <label class="ts-text-xs">
                  {{
                    $t(
                      'school.academic.setup.program.subject.activity_subjects.assessment_components'
                    )
                  }}
                </label>
                <div>
                  <a
                    href="#"
                    v-tooltip="$t('scoreComponent.addMoreComponent')"
                    @click.prevent="addNewComponent"
                  >
                    <i class="far fa-plus-square"></i>
                  </a>
                </div>
              </div>
              <table style="width:100%" class="mt-1">
                <draggable tag="tbody" v-model="model.component_list">
                  <tr
                    v-for="(item, index) in model.component_list"
                    :key="index"
                  >
                    <td style="padding: 3px 8px 7px 0;">
                      <input
                        v-model.trim="item.comp_item_name"
                        type="text"
                        class="bb"
                        style="width:100%"
                      />
                    </td>
                    <td style="width:10px" valign="top">
                      <a
                        href="#"
                        class="text-danger"
                        @click.prevent="removeItem(index)"
                      >
                        <i class="fas fa-times"></i>
                      </a>
                    </td>
                  </tr>
                </draggable>
              </table>
            </div>
          </div>
        </div>
        <div class="row ts-mt-6">
          <div class="col-sm-12 col-lg-12 col-md-12 text-right">
            <ts-button @click.prevent="$emit('close')" :disabled="saving">{{
              $t('cancel')
            }}</ts-button>
            <ts-button
              color="primary"
              class="ml-2"
              :waiting="saving"
              @click.prevent="submit"
              >{{ $t('save') }}</ts-button
            >
          </div>
        </div>
      </form>
    </ts-card-wrapper>
  </ts-card>
</template>

<script>
import draggable from 'vuedraggable'
import { Errors } from 'form-backend-validation'

export default {
  name: 'subject-activity-form',
  props: ['editData'],
  components: {
    draggable
  },
  data () {
    return {
      model: {
        subject_name_native: this.editData
          ? this.editData.subject_name_native
          : '',
        subject_name_foreign: this.editData
          ? this.editData.subject_name_foreign
          : '',
        ministry_name_foreign: this.editData
          ? this.editData.ministry_name_foreign
          : '',
        ministry_name_native: this.editData
          ? this.editData.ministry_name_native
          : '',
        subject_order: this.editData ? this.editData.subject_order : '',
        total_hour: this.editData ? this.editData.total_hour : '',
        credit_theory: this.editData ? this.editData.credit_theory : '',
        credit_practice: this.editData ? this.editData.credit_practice : '',
        credit_intern: this.editData ? this.editData.credit_intern : '',
        display_column: this.editData ? this.editData.display_column : '',
        component_list:
          this.editData && this.editData.component_list
            ? this.editData.component_list.map(comp => ({
                subject_comp_id: comp.subject_comp_id,
                comp_item_name: comp.comp_item_name,
                display_order: comp.display_order
              }))
            : []
      },
      errors: new Errors(),
      saving: false
    }
  },
  computed: {
    formTitle () {
      return _.isEmpty(this.editData)
        ? 'New activity subject'
        : 'Edit activity subject'
    }
  },
  created () {},
  methods: {
    addNewComponent (event) {
      this.model.component_list.push({
        subject_comp_id: 0,
        comp_item_name: event.target.value,
        display_order: this.model.component_list.length
      })
    },
    removeItem (index) {
      this.model.component_list.splice(index, 1)
    },
    submit () {
      let response

      this.errors = new Errors()
      this.saving = true

      if (this.editData) {
        response = this.$store.dispatch('subjectActivity/update', {
          subject_id: this.editData.subject_id,
          ...this.model
        })
      } else {
        response = this.$store.dispatch('subjectActivity/store', this.model)
      }

      response
        .then(response => {
          this.$store.dispatch('subjectActivity/fetch').then(() => {
            this.saving = false
            this.$toasted.success(response.message)
            this.$emit('close')
          })
        })
        .catch(error => {
          this.saving = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    }
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('subjectActivity/RESET_STATE')
    }
    next()
  }
}
</script>
<style scoped>
.bb {
  border: none;
  outline: none !important;
  padding: 3px 7px;
  border-radius: 5px;
}

</style>
